import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_ICON_SIZE = 24;

const sizePropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

function TrainIcon({ w, h, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M14.667 16.667c0 .738.595 1.333 1.333 1.333s1.333-.595 1.333-1.333-.595-1.333-1.333-1.333-1.333.595-1.333 1.333zm-7.43-4.592C8.826 13.359 10.414 14 12 14c1.587 0 3.175-.641 4.762-1.925A3.33 3.33 0 0018 9.483v-.372c0-1.085-.8-2.005-1.875-2.155a29.64 29.64 0 00-8.25 0A2.176 2.176 0 006 9.111v.372a3.33 3.33 0 001.238 2.592zm-.569 4.592c0 .738.595 1.333 1.333 1.333s1.332-.595 1.332-1.333S8.738 15.334 8 15.334s-1.333.595-1.333 1.333zm9.889 4.143c-1.31.753-2.89 1.19-4.556 1.19-1.663 0-3.243-.436-4.551-1.187l-.919 1.53a.665.665 0 01-.571.324h-.623a.566.566 0 01-.486-.857l1.206-2.01C4.788 18.642 4 17.106 4 15.392V7.573c0-3.126 4.288-4.906 7.91-4.906 4 0 8.09 1.78 8.09 4.906v7.818c0 1.712-.787 3.247-2.053 4.406l1.208 2.013a.565.565 0 01-.485.857h-.623a.666.666 0 01-.571-.324l-.92-1.533zM12 3.334a1.333 1.333 0 100 2.667 1.333 1.333 0 000-2.667z" />
    </svg>
  );
}

TrainIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

TrainIcon.propTypes = {
  w: sizePropType,
  h: sizePropType,
};

TrainIcon.defaultProps = {
  w: DEFAULT_ICON_SIZE,
  h: DEFAULT_ICON_SIZE,
};

export default TrainIcon;
